import React, { useState, useContext } from "react";
import { Disclaimer } from "../components/Disclaimer";
import { NTNSearch } from "../components/NTNSearch";
import { NameSearch } from "../components/NameSearch";
import { FBRDataContext } from "../context/FBRDataContext";

export function SearchPage({ t }) {
  const { recordCount } = useContext(FBRDataContext);
  const [tab, setTab] = useState("ntn");
  return (
    <div className="container">
      <div className="page-header">
        <h2 className="page-title">{t("search_title")}</h2>
        <p className="page-sub">{t("search_sub")} {recordCount.toLocaleString()} {t("records_loaded")}.</p>
      </div>
      <Disclaimer t={t} />

      <div className="form-card" style={{ padding:0, overflow:"hidden" }}>
        <div className="search-tab-row">
          <button className={`search-tab ${tab === "ntn"  ? "search-tab-active" : ""}`} onClick={() => setTab("ntn")}>
            🔢 {t("search_by_ntn")}
          </button>
          <button className={`search-tab ${tab === "name" ? "search-tab-active" : ""}`} onClick={() => setTab("name")}>
            🏪 {t("search_by_name")}
          </button>
        </div>
        <div style={{ padding:"28px 32px" }}>
          {tab === "ntn"  && <NTNSearch t={t} />}
          {tab === "name" && <NameSearch t={t} />}
        </div>
      </div>

      <div className="info-card" style={{ marginTop:4 }}>
        <div className="section-title" style={{ fontSize:14, marginBottom:12 }}>{t("how_search_works")}</div>
        <div className="check-list">
          <div className="check-item check-neutral">🔢 Enter NTN as <code>7221683-2</code>, SNTN as <code>S7221683-2</code>, or bare digits <code>7221683</code> — all are handled automatically</div>
          <div className="check-item check-neutral">🏛️ SNTN: the S prefix is stripped before searching FBR's database, since FBR stores plain NTNs</div>
          <div className="check-item check-neutral">⚠️ If the check digit on your receipt is wrong, the business is still found using the 7-digit base — and you're shown the mismatch</div>
          <div className="check-item check-neutral">🔍 Name search looks across both taxpayer name and business name fields</div>
        </div>
      </div>
    </div>
  );
}
